import React from 'react'
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'

require('highcharts/modules/exporting')(Highcharts)
require('highcharts/modules/export-data')(Highcharts)
require('highcharts/modules/data')(Highcharts)

const DonutChart = ({ options }) => {
  return (
    // <div className="highcharts-figure">
    // <div id="container">
    <HighchartsReact
      containerProps={{ style: { height: '100%' } }}
      highcharts={Highcharts}
      options={options}
    />
    // </div>
    // </div>
  )
}

export default DonutChart
